/* tslint:disable */
/* eslint-disable */
/**
 * GlassHouse.Dashboard.Api | v1
 * No description provided (generated by Openapi Generator https://github.com/openapitools/openapi-generator)
 *
 * The version of the OpenAPI document: 1.0.0
 * 
 *
 * NOTE: This class is auto generated by OpenAPI Generator (https://openapi-generator.tech).
 * https://openapi-generator.tech
 * Do not edit the class manually.
 */

import { mapValues } from '../runtime';
import type { ScheduledDropEnrollmentRow } from './ScheduledDropEnrollmentRow';
import {
    ScheduledDropEnrollmentRowFromJSON,
    ScheduledDropEnrollmentRowFromJSONTyped,
    ScheduledDropEnrollmentRowToJSON,
    ScheduledDropEnrollmentRowToJSONTyped,
} from './ScheduledDropEnrollmentRow';

/**
 * 
 * @export
 * @interface WidgetDataScheduledDropEnrollmentsWidgetData
 */
export interface WidgetDataScheduledDropEnrollmentsWidgetData {
    /**
     * 
     * @type {string}
     * @memberof WidgetDataScheduledDropEnrollmentsWidgetData
     */
    $type?: WidgetDataScheduledDropEnrollmentsWidgetDataTypeEnum;
    /**
     * 
     * @type {Array<ScheduledDropEnrollmentRow>}
     * @memberof WidgetDataScheduledDropEnrollmentsWidgetData
     */
    items: Array<ScheduledDropEnrollmentRow>;
}


/**
 * @export
 */
export const WidgetDataScheduledDropEnrollmentsWidgetDataTypeEnum = {
    ScheduledDropEnrollments: 'scheduled-drop-enrollments'
} as const;
export type WidgetDataScheduledDropEnrollmentsWidgetDataTypeEnum = typeof WidgetDataScheduledDropEnrollmentsWidgetDataTypeEnum[keyof typeof WidgetDataScheduledDropEnrollmentsWidgetDataTypeEnum];


/**
 * Check if a given object implements the WidgetDataScheduledDropEnrollmentsWidgetData interface.
 */
export function instanceOfWidgetDataScheduledDropEnrollmentsWidgetData(value: object): value is WidgetDataScheduledDropEnrollmentsWidgetData {
    if (!('items' in value) || value['items'] === undefined) return false;
    return true;
}

export function WidgetDataScheduledDropEnrollmentsWidgetDataFromJSON(json: any): WidgetDataScheduledDropEnrollmentsWidgetData {
    return WidgetDataScheduledDropEnrollmentsWidgetDataFromJSONTyped(json, false);
}

export function WidgetDataScheduledDropEnrollmentsWidgetDataFromJSONTyped(json: any, ignoreDiscriminator: boolean): WidgetDataScheduledDropEnrollmentsWidgetData {
    if (json == null) {
        return json;
    }
    return {
        
        '$type': json['$type'] == null ? undefined : json['$type'],
        'items': ((json['items'] as Array<any>).map(ScheduledDropEnrollmentRowFromJSON)),
    };
}

export function WidgetDataScheduledDropEnrollmentsWidgetDataToJSON(json: any): WidgetDataScheduledDropEnrollmentsWidgetData {
    return WidgetDataScheduledDropEnrollmentsWidgetDataToJSONTyped(json, false);
}

export function WidgetDataScheduledDropEnrollmentsWidgetDataToJSONTyped(value?: WidgetDataScheduledDropEnrollmentsWidgetData | null, ignoreDiscriminator: boolean = false): any {
    if (value == null) {
        return value;
    }

    return {
        
        '$type': value['$type'],
        'items': ((value['items'] as Array<any>).map(ScheduledDropEnrollmentRowToJSON)),
    };
}

